import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260303_make_option_set_ref_extend_doc_entity_base",
  description: "Make OptionSetRef extend DocEntityBase",
  apply(json: any) {
    if (!Object.keys(json.optionSetRefs ?? {}).length) {
      return json;
    }

    for (const id in json.optionSetRefs) {
      const optionSetRef = json.optionSetRefs[id];

      const optionSet = json.optionSets?.[optionSetRef.optionSetId];

      json.optionSetRefs[id] = {
        ...optionSetRef,
        entityType: "OPTION_SET_REF",
        name: optionSet?.name ?? "",
      };
    }

    return json;
  },
};

export default migration;
